"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var FieldValidator_1 = __importDefault(require("./FieldValidator"));
console.debug('INFO FormValidator.ts loaded');
var FormValidator = /** @class */ (function () {
    function FormValidator(form) {
        var _this = this;
        this.form = form;
        this.form
            .querySelectorAll('input:not([type=radio]):not([type=checkbox]):not([type=file]),select,textarea')
            .forEach(function (item) {
            item.addEventListener('blur', function () {
                void _this.validateField(item);
            });
        });
        // for all checkbox groups with required attribute, remove required attribute when at least one checkbox is checked
        this.form.querySelectorAll('input[type=checkbox][required]').forEach(function (item) {
            item.addEventListener('click', function () {
                var fieldset = item.closest('.js-checkbox');
                var isOneChecked = fieldset.querySelectorAll(':checked').length > 0;
                fieldset.querySelectorAll('.c-checkbox__input').forEach(function (checkbox) {
                    if (isOneChecked) {
                        checkbox.removeAttribute('required');
                    }
                    else {
                        checkbox.setAttribute('required', 'required');
                        checkbox.dataset.requiredChanged = 'true';
                    }
                });
            });
        });
        this.form.querySelectorAll('input[type=radio],input[type=checkbox]').forEach(function (item) {
            // Handle both change (click/space) and blur (tabbing away)
            var handler = function () {
                _this._syncChoiceGroupRequired(item);
                var rep = _this._getChoiceGroupRepresentative(item);
                void _this.validateField(rep);
            };
            item.addEventListener('change', handler);
            item.addEventListener('blur', handler);
        });
        this.form.querySelectorAll('.js-datepicker').forEach(function (item) {
            item.addEventListener('bronson_datepickerClose', function () {
                void _this.validateField(item.querySelector('input'));
            });
        });
        this.genericErrorId = '#error-' + this.form.id;
        this.form.querySelectorAll('input[type=radio],input[type=checkbox]').forEach(function (item) {
            _this._syncChoiceGroupRequired(item);
        });
    }
    FormValidator.prototype.validateForm = function (isSubmit) {
        return __awaiter(this, void 0, void 0, function () {
            var valid;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.form.noValidate) return [3 /*break*/, 2];
                        this._resetFormValidationStatus();
                        return [4 /*yield*/, this._initializeFieldValidators()];
                    case 1:
                        _a.sent();
                        valid = this.form.checkValidity();
                        if (valid === false) {
                            this._setFormValidationStatus(isSubmit);
                        }
                        return [2 /*return*/, valid];
                    case 2: return [2 /*return*/, true];
                }
            });
        });
    };
    FormValidator.prototype.validateField = function (field) {
        return __awaiter(this, void 0, void 0, function () {
            var valid, genericErrorElement;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!field.hasAttribute('data-novalidate')) return [3 /*break*/, 2];
                        this._resetFieldValidationStatus(field);
                        return [4 /*yield*/, this.fieldIsValid(field)];
                    case 1:
                        valid = _a.sent();
                        if (valid === false) {
                            this._setFieldValidationStatus(field);
                        }
                        else if (this.form.checkValidity() === true) {
                            genericErrorElement = this.form.querySelector(this.genericErrorId);
                            genericErrorElement.classList.add('u-hide');
                            genericErrorElement.setAttribute('aria-hidden', 'true');
                        }
                        return [2 /*return*/, valid];
                    case 2: return [2 /*return*/, true];
                }
            });
        });
    };
    FormValidator.prototype.fieldIsValid = function (field) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._initializeFieldValidator(field)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, field.checkValidity()];
                }
            });
        });
    };
    /**
     * reset existing validation status
     */
    FormValidator.prototype._resetFormValidationStatus = function () {
        var genericErrorElement = this.form.querySelector(this.genericErrorId);
        genericErrorElement.classList.remove('u-hide');
        genericErrorElement.setAttribute('aria-hidden', 'false');
        this.form.querySelectorAll('[aria-invalid="true"]').forEach(function (item) {
            item.removeAttribute('aria-invalid');
        });
        this.form.querySelectorAll('.c-error-message').forEach(function (item) {
            item.classList.add('u-hide');
            item.setAttribute('aria-hidden', 'true');
        });
        this.form.querySelectorAll('input:invalid,select:invalid,textarea:invalid').forEach(function (item) {
            item.setCustomValidity('');
        });
    };
    FormValidator.prototype._resetFieldValidationStatus = function (field) {
        field.removeAttribute('aria-invalid');
        if (field.getAttribute('type') === 'radio' || field.getAttribute('type') === 'checkbox') {
            var attribute = field.dataset.targetId;
            this.form.querySelectorAll("[data-target-id=".concat(attribute, "]")).forEach(function (item) {
                item.removeAttribute('aria-invalid');
            });
        }
        if (field.parentElement.nextElementSibling) {
            field.parentElement.nextElementSibling.classList.add('u-hide');
            field.parentElement.nextElementSibling.setAttribute('aria-hidden', 'true');
        }
        else {
            var attribute = field.dataset.targetId;
            if (attribute) {
                this.form.querySelectorAll('.' + attribute).forEach(function (item) {
                    item.classList.add('u-hide');
                    item.setAttribute('aria-hidden', 'true');
                });
            }
        }
    };
    /**
     * set validation status for all invalid form fields
     */
    FormValidator.prototype._setFormValidationStatus = function (isSubmit) {
        var _this = this;
        var genericErrorElememnt = this.form.querySelector(this.genericErrorId);
        genericErrorElememnt.classList.remove('u-hide');
        genericErrorElememnt.setAttribute('aria-hidden', 'false');
        this.form.querySelectorAll('input:invalid,select:invalid,textarea:invalid').forEach(function (item) {
            _this._setFieldValidationStatus(item);
        });
        if (isSubmit) {
            this._scrollToFirstError();
        }
    };
    FormValidator.prototype._setFieldValidationStatus = function (field) {
        var validator = this._getFieldValidator(field);
        if (validator.getMessages().length > 0) {
            field.setAttribute('aria-invalid', 'true');
            if (field.getAttribute('type') === 'radio' || field.getAttribute('type') === 'checkbox') {
                var attribute = field.dataset.targetId;
                this.form.querySelectorAll("[data-target-id=".concat(attribute, "]")).forEach(function (item) {
                    item.setAttribute('aria-invalid', 'true');
                });
            }
            if (field.parentElement.nextElementSibling) {
                field.parentElement.nextElementSibling.innerHTML = validator.getMessages()[0];
                field.parentElement.nextElementSibling.classList.remove('u-hide');
                field.parentElement.nextElementSibling.setAttribute('aria-hidden', 'false');
            }
            else {
                var attribute = field.dataset.targetId;
                if (attribute) {
                    this.form.querySelectorAll('.' + attribute).forEach(function (item) {
                        item.innerHTML = validator.getMessages()[0];
                        item.classList.remove('u-hide');
                        item.setAttribute('aria-hidden', 'false');
                    });
                }
            }
        }
    };
    /**
     * initialize (custom) validators and messages
     */
    FormValidator.prototype._initializeFieldValidators = function () {
        return __awaiter(this, void 0, void 0, function () {
            var fields, _i, fields_1, item;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        fields = Array.from(this.form.querySelectorAll('input,select,textarea'));
                        _i = 0, fields_1 = fields;
                        _a.label = 1;
                    case 1:
                        if (!(_i < fields_1.length)) return [3 /*break*/, 4];
                        item = fields_1[_i];
                        return [4 /*yield*/, this._initializeFieldValidator(item)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FormValidator.prototype._initializeFieldValidator = function (field) {
        return __awaiter(this, void 0, void 0, function () {
            var fieldValidator;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        fieldValidator = this._getFieldValidator(field);
                        return [4 /*yield*/, fieldValidator.runCustomValidations()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    FormValidator.prototype._getFieldValidator = function (field) {
        var validator = field.validator;
        if (!validator || field.dataset.requiredChanged === 'true') {
            validator = new FieldValidator_1.default(field);
            field.validator = validator;
        }
        return validator;
    };
    FormValidator.prototype._scrollToFirstError = function () {
        var element = this.form.querySelector('[aria-invalid="true"]');
        if (element) {
            var jumpnav = document.querySelector('.js-section-nav');
            var jumpnavHeight = 0;
            if (jumpnav) {
                jumpnavHeight = jumpnav.scrollHeight;
            }
            var bodyRect = document.body.getBoundingClientRect(), elemRect = element.getBoundingClientRect(), offset = elemRect.top - bodyRect.top - jumpnavHeight - 200;
            window.scrollTo(0, offset);
        }
        else {
            console.debug('Error: FormValidator.ts: Error element is null.');
        }
    };
    FormValidator.prototype._getChoiceGroupRepresentative = function (field) {
        if (!field.form || !field.name)
            return field;
        var group = Array.from(field.form.querySelectorAll('input[name="' + field.name + '"]'));
        return group[0] || field;
    };
    FormValidator.prototype._syncChoiceGroupRequired = function (field) {
        var type = (field.type || '').toLowerCase();
        if (type !== 'radio' && type !== 'checkbox')
            return;
        if (!field.form || !field.name)
            return;
        var group = Array.from(field.form.querySelectorAll('input[name="' + field.name + '"]'));
        if (group.length === 0)
            return;
        var authorRequired = group.some(function (el) { return el.hasAttribute('required') || el.dataset.keepRequired === 'true'; });
        if (!authorRequired) {
            return;
        }
        var anyChecked = group.some(function (el) { return el.checked; });
        group.forEach(function (el) { return el.removeAttribute('required'); });
        if (!anyChecked) {
            var rep = group[0];
            rep.setAttribute('required', 'required');
        }
        group.forEach(function (el) {
            el.dataset.requiredChanged = 'true';
        });
    };
    return FormValidator;
}());
exports.default = FormValidator;
